// Framework

/*** Selectors ***/
export const getEmailFromForm = (state) => state.formValues.email;
export const getPasswordFromForm = (state) => state.formValues.password;

// Actions
export const SET_FORM_VALUE = 'AUTH/SET_FORM_VALUE';
export const CLEAR_FORM = 'AUTH/CLEAR_FORM';

/*** Action Creators ***/
export const setFormValue = (action) => ({
  type: SET_FORM_VALUE,
  action
});

export const clearForm = () => ({
  type: CLEAR_FORM
});

/*** Reducer ***/
export const DEFAULT_STATE = {};

export default function FormReducer(
  state = DEFAULT_STATE,
  { action, type } = {}
) {
  switch (type) {
    case SET_FORM_VALUE: {
      let data = {
        ...state
      };
      data[action.name] = action.value;
      return data;
    }
    case CLEAR_FORM:
      return DEFAULT_STATE;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/actions/auth/form.js